module.exports = __webpack_public_path__ + "img/voltaje_b_gray.1d8ecc9b.svg";